export default () => ({
  marketplaceList: [],
  totalItems: 0,
});
